import {connect} from "react-redux";
import {getAppointmentSlot, setAppointment} from "../../../../actions/action";
import Appointment from '../component/Appointment';
import { Toaster, Intent, Position } from '@blueprintjs/core';


const mapStateToProps = state =>{

    return{
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        getAppointmentSlot : (obj) =>{
            return getAppointmentSlot(obj)
                .catch((error) => {
                    if (error.response && error.response.status !== 401) {
                        Object.keys(error.response.data.error).forEach((key) => {
                            error.response.data.error[key].forEach((error) => {
                                Toaster.create({position: Position.TOP}).show({
                                    message: error,
                                    intent: Intent.DANGER
                                });
                            });
                        });
                    }
                });
        },

        setAppointment : (obj) =>{
            return setAppointment(obj)
                .catch((error) => {
                    if (error.response && error.response.status !== 401) {
                        Object.keys(error.response.data.error).forEach((key) => {
                            error.response.data.error[key].forEach((error) => {
                                Toaster.create({position: Position.TOP}).show({
                                    message: error,
                                    intent: Intent.DANGER
                                });
                            });
                        });
                    }
                });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Appointment)